<script setup>
import {postMetadata} from '~/utils/post-metadata.mjs';
const props=defineProps({postId:[String,Number],title:String,text:String,cover:String,metadata:Object,photos:Array});
const details=computed(()=>postMetadata({id:props.postId,title:props.title,text:props.text,metadata:props.metadata,photos:props.photos}));
const excerpt=computed(()=>details.value.excerpt);
const selectedCover=computed(()=>details.value.image?.url||props.cover);
</script>
<template><NuxtLink class="uo-post-preview" :to="'/feed/'+postId"><h2>{{title}}</h2><p v-if="excerpt" class="uo-post-excerpt">{{excerpt}}</p><img v-if="selectedCover" class="uo-post-cover" :src="selectedCover" :alt="title" loading="lazy"/><span class="uo-text-link">Читать пост →</span></NuxtLink></template>
